<template>
  <div 
    class="xit-fb-template node" 
    :class="[node.name]" 
  >
    <div class="card-body-handler card_data_body p-0">
      <div class="">
        <div class="card-sockets">
          <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
            <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
            <div class="input-title">{{input.name}}</div>
          </div>
        </div>

        <ul class="list-group">
          <li 
            :key="index"
            class="list-group-item"
            v-for="(input, index) in node.compatibleInputs"
            @click.stop="handleClickOnList(node, $event)"
            :data-input-socket-name="input" 
            :data-component-name="getComponentName(input).name" 
          >{{ getComponentName(input).lingualName }}</li>
          
          <li @click.stop="handleClickOnList(node, $event)" class="list-group-item">Cancel</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'

import { App } from '../../App'
import { socketToComponent } from '../../data'
import { 
  templateComponentMethods, 
  createNodeOnClickComponentList 
} from '../../utils/functions'

export default {
  name: 'ComponentListTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  methods: {
    ...templateComponentMethods,

    async handleClickOnList(node, event) {
      if ((! event.target.dataset.componentName) || (! event.target.dataset.inputSocketName)) {
        App.editor.removeNode(node)
        return;
      }

      const output = node.output.node.outputs.get(node.output.key)

      if (output.connections.length > 0) {
        output.connections.forEach(c => App.editor.removeConnection(c))
      }

      // Stop adding new node when multiple connections are not allowed
      if (output.connections.length > 0 && (false === output.multipleConnections)) {
        App.editor.removeNode(node)
        return;
      }
      
      return await createNodeOnClickComponentList(node, event)
    },

    getComponentName(input) {
      return socketToComponent[input]
    }
  }
}
</script>

<style lang="scss" scoped>
  .xit-fb-template {
    border: none !important;
    .list-group-item {
      font-size: .75rem;
      line-height: 1.25rem;
      padding: 0.25rem 0.75rem;
    }
  }
</style>